module.exports = __webpack_public_path__ + "img/section_card3.03b70f95.png";